import React, { useEffect, useState } from "react";
import store from "../../redux/store";
import {
  Box,
  Card,
  Flex,
  Heading,
  Input,
  InputGroup,
  InputRightElement,
  Select,
  SimpleGrid,
  Spacer,
  Text,
} from "@chakra-ui/react";
import { FiChevronLeft, FiChevronRight, FiSearch } from "react-icons/fi";
import { useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import DisplayData from "../../components/DisplayData";
import { get_quotation_list } from "../../redux/quotationSlice";
import GasCylinderLoader from "../../components/GasCylinderLoader";

const Quotation = () => {
  const navigate = useNavigate();
  const [rows, setRows] = useState(10);
  const [page, setpage] = useState(1);
  const [initialValue, setInitialValue] = useState(1);
  const [searchQuery, setSearchQuery] = useState(""); // 🔍 For filtering
  const location = useLocation();
  const { quotation_list, total_quotation_count,loading } = useSelector(
    (state) => state.quotation
  );

  useEffect(() => {
    if (location.state) {
      const { page, rows, initialValue } = location.state;
      if (page !== undefined) setpage(page);
      if (rows !== undefined) setRows(rows);
      if (initialValue !== undefined) setInitialValue(initialValue);
      store.dispatch(get_quotation_list({ page, rows }));
    } else {
      store.dispatch(get_quotation_list({ page, rows }));
    }
  }, []);

  const onPrevious = () => {
    initialValue == 1 || setInitialValue(Number(initialValue) - Number(rows));
    page == 1 || setpage(page - 1);
    page === 1 ||
      store.dispatch(get_quotation_list({ page: page - 1, rows: rows }));
  };

  const onNext = () => {
    rows * page >= total_quotation_count ||
      setInitialValue(Number(initialValue) + Number(rows));
    rows * page >= total_quotation_count || setpage(page + 1);
    rows * page >= total_quotation_count ||
      store.dispatch(get_quotation_list({ page: page + 1, rows: rows }));
  };

  // 🔍 Filter quotation_list based on name or quotation number
  const filteredQuotations = quotation_list?.filter(
    (el) =>
      el.customer_name?.toLowerCase().includes(searchQuery.toLowerCase()) ||
      el.sr_no?.toLowerCase().includes(searchQuery.toLowerCase())
  );

  return (
    <>
      <Card
        bg="#fff"
        paddingInline={5}
        paddingBlock={2}
        display="flex"
        flexDirection={["column", "column", "row"]}
        alignItems={["stretch", "stretch", "center"]}
        gap={3}
        flexWrap="wrap"
      >
        <Heading fontSize="xl" flexShrink={0}>
          Quotation List
        </Heading>

        <Spacer display={["none", "none", "block"]} />

        <Flex
          direction={["column", "row"]}
          gap={2}
          alignItems="center"
          justifyContent={["flex-start", "flex-end"]}
          flex="1"
          flexWrap="wrap"
        >
          <Select
            placeholder="Rows"
            size="md"
            w={["100%", "100px"]}
            value={rows}
            onChange={(e) => {
              store.dispatch(get_quotation_list({ page, rows: e.target.value }));
              setRows(e.target.value);
            }}
          >
            <option value="5">5</option>
            <option value="10">10</option>
            <option value="25">25</option>
            <option value="50">50</option>
            <option value="100">100</option>
          </Select>

          {/* 🔍 Search input (filters by name or quotation no.) */}
          <InputGroup bg="#f4f5f7" borderRadius={5} w={["100%", "auto"]} maxW="sm">
            <Input
              placeholder="Search by Name or Quotation No..."
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
            />
            <InputRightElement>
              <FiSearch />
            </InputRightElement>
          </InputGroup>
        </Flex>
      </Card>
      {loading ? (<GasCylinderLoader size="sm" loadingText="Loading Quotation list"/>
    ):(
    <>

<SimpleGrid minChildWidth="xs" spacing="10px">
        {filteredQuotations?.map((el, i) => (
          <Card
            key={el.id}
            paddingInline={5}
            paddingBlock={2}
            cursor="pointer"
            display="flex"
            flexDirection="column"
            justifyContent="space-between"
            _hover={{ boxShadow: "md", transform: "translateY(-3px)" }}
            transition="all 0.2s ease"
            onClick={() =>
              navigate("/quotation/quotation-detail", {
                state: {
                  id: el.id,
                  page,
                  rows,
                  initialValue,
                },
              })
            }
          >
            {/* Header */}
            <DisplayData
              fs="16px"
              v_color="#169e49"
              fw="bold"
              value={el.customer_name || "NA"}
            />

            {/* Details */}
            <Box mt={1}>
              {[
                { title: "Quotation No.", value: el.sr_no },
                { title: "Date & Time", value: el.datetime },
                {
                  title: "Total Amount",
                  value:
                    el.products && el.products.length > 0
                      ? `₹${el.products
                          .reduce(
                            (total, product) =>
                              total +
                              parseFloat(product.qty || 0) *
                                parseFloat(product.price || 0),
                            0
                          )
                          .toFixed(2)}`
                      : "NA",
                },
              ].map((item, idx) => (
                <Flex
                  key={idx}
                  justify="space-between"
                  align="center"
                  mb="1"
                  wrap="nowrap"
                >
                  <Text fontSize="sm" color="gray.600" flex="1" noOfLines={1}>
                    {item.title}
                  </Text>
                  <Text
                    fontSize="sm"
                    color="gray.800"
                    flex="1"
                    textAlign="right"
                    noOfLines={1}
                  >
                    {item.value || "NA"}
                  </Text>
                </Flex>
              ))}
            </Box>
          </Card>
        ))}
      </SimpleGrid>

      <Card
        alignItems={"center"}
        alignSelf={"end"}
        gap={3}
        flexDirection={"row"}
      >
        <FiChevronLeft
          cursor={"pointer"}
          color={page == 1 ? "gray" : "#007bc9"}
          size={35}
          onClick={onPrevious}
        />

        <Flex gap={3}>
          <Text>{initialValue}</Text>-
          <Text>
            {rows * page >= total_quotation_count
              ? total_quotation_count
              : rows * page}
          </Text>
          <Text>of</Text>
          <Text>{total_quotation_count}</Text>
        </Flex>

        <FiChevronRight
          cursor={"pointer"}
          color={rows * page >= total_quotation_count ? "gray" : "#007bc9"}
          size={35}
          onClick={onNext}
        />
      </Card>
    </>)}

    </>
  );
};

export default Quotation;
